module.exports = __webpack_public_path__ + "static/media/404.342ca649.svg";